import { render, staticRenderFns } from "./AttributeDropdown.vue?vue&type=template&id=0e0481fd&"
import script from "./AttributeDropdown.vue?vue&type=script&lang=js&"
export * from "./AttributeDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports